var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7291 12.0834H14.6875C14.3998 12.0834 14.1666 12.3166 14.1666 12.6042V16.2501H3.74996V5.83342H8.43746C8.72511 5.83342 8.95829 5.60023 8.95829 5.31258V4.27091C8.95829 3.98327 8.72511 3.75008 8.43746 3.75008H3.22913C2.36618 3.75008 1.66663 4.44964 1.66663 5.31258V16.7709C1.66663 17.6339 2.36618 18.3334 3.22913 18.3334H14.6875C15.5504 18.3334 16.25 17.6339 16.25 16.7709V12.6042C16.25 12.3166 16.0168 12.0834 15.7291 12.0834ZM17.552 1.66675H13.3854C12.6897 1.66675 12.3421 2.51017 12.832 3.00138L13.9951 4.16447L6.06116 12.0955C5.91406 12.2421 5.83138 12.4412 5.83138 12.6488C5.83138 12.8565 5.91406 13.0556 6.06116 13.2022L6.79911 13.9389C6.9457 14.086 7.14483 14.1687 7.3525 14.1687C7.56017 14.1687 7.75929 14.086 7.90588 13.9389L15.8359 6.00659L16.9987 7.16805C17.4869 7.65633 18.3333 7.31453 18.3333 6.61467V2.448C18.3333 2.01653 17.9835 1.66675 17.552 1.66675Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.43bc869ea319a044d8ae02c23ba24208.svg";
export { ForwardRef as ReactComponent };